exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-wrapper[data-v-6d9ec77a] {\n  min-width: 28px;\n  min-height: 28px;\n  padding: 4px;\n  border: solid 2px #140911;\n  background: white;\n}\n.img-wrapper img[data-v-6d9ec77a] {\n    cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d9ec77a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/atoms/buttons/QuestionButton.vue
// module id = tz04
// module chunks = 0